import { useEffect, useState } from 'react';
import { api } from '@/api/client';

interface PromptPreviewModalProps {
  vacancyId: string;
  onClose: () => void;
}

interface PromptData {
  system_prompt: string;
  user_prompt: string;
  model: string;
  has_instructions: boolean;
}

export default function PromptPreviewModal({ vacancyId, onClose }: PromptPreviewModalProps) {
  const [data, setData] = useState<PromptData | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get<PromptData>(`/vacancies/${vacancyId}/prompt-preview`)
      .then(setData)
      .catch((e) => setError((e as Error).message || 'Не удалось получить промпт'));
  }, [vacancyId]);

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center overflow-y-auto p-4 md:p-8" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-3xl shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-200">
          <div>
            <h3 className="text-base font-heading font-semibold text-foreground-900">Что уходит в модель</h3>
            <p className="text-xs text-foreground-500 mt-0.5">
              Полный текст запроса при генерации вопросов
              {data?.model ? ` · модель: ${data.model}` : ''}
            </p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-background-100 flex items-center justify-center cursor-pointer" aria-label="Закрыть">
            <i className="ri-close-line text-foreground-500" />
          </button>
        </div>

        <div className="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">
          {error && <div className="p-3 rounded-xl bg-red-50 border border-red-100 text-red-700 text-sm">{error}</div>}
          {!data && !error && <p className="text-sm text-foreground-400">Загружаю…</p>}
          {data && (
            <>
              {!data.has_instructions && (
                <div className="p-3 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-sm">
                  Своя инструкция не задана — модель работает только по общим правилам. Заполните поле
                  «Инструкция для AI» выше, и она попадёт сюда с приоритетом над общими правилами.
                </div>
              )}
              <div>
                <p className="text-xs font-semibold text-foreground-700 mb-1.5">Правила для модели (методика вопросов)</p>
                <pre className="text-xs text-foreground-600 bg-background-50 border border-background-200 rounded-xl p-4 whitespace-pre-wrap font-mono leading-relaxed">
                  {data.system_prompt}
                </pre>
              </div>
              <div>
                <p className="text-xs font-semibold text-foreground-700 mb-1.5">Данные по вакансии</p>
                <pre className="text-xs text-foreground-600 bg-background-50 border border-background-200 rounded-xl p-4 whitespace-pre-wrap font-mono leading-relaxed">
                  {data.user_prompt}
                </pre>
              </div>
            </>
          )}
        </div>

        <div className="px-6 py-4 border-t border-background-200 flex justify-end">
          <button onClick={onClose} className="px-4 py-2.5 rounded-xl text-sm text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer">
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}
